<template>
    <div class="is-marginless" @click.stop>
        <div>
            <div v-for="item in items" :key="item._id">
                <article
                    class="media py-3 pl-4 pr-2 object-element"
                    @click="centerMap(item)"
                >
                    <figure class="media-left">
                        <span class="icon is-large has-text-grey"
                            ><i :class="getObjectTypeIcon(item)"></i
                        ></span>
                    </figure>
                    <div class="media-content">
                        <div class="content">
                            <nav class="level is-mobile mb-0">
                                <div class="level-left">
                                    <p
                                        class="
                                            level-item
                                            has-text-weight-bold
                                            is-size-6
                                        "
                                    >
                                        {{ item.title }}
                                    </p>
                                </div>
                                <div class="level-right">
                                    <div class="level-item">
                                        <p
                                            :data-tooltip="
                                                item.owner.alias ||
                                                item.owner.name
                                            "
                                            class="
                                                image
                                                is-24x24
                                                has-tooltip-bottom
                                            "
                                        >
                                            <img
                                                :src="item.owner.avatar"
                                                referrerpolicy="no-referrer"
                                                loading="lazy"
                                                class="is-rounded lb-avatar"
                                            />
                                        </p>
                                    </div>
                                </div>
                            </nav>
                            <div
                                v-if="item.description"
                                class="is-clipped is-size-7"
                            >
                                {{ item.description | strippedContent }}
                            </div>
                        </div>
                        <nav class="level is-mobile">
                            <div class="level-left"></div>
                            <div class="level-right">
                                <span
                                    class="level-item"
                                    v-if="item.images.length"
                                >
                                    <span class="icon is-small"
                                        ><i class="fa-lg fas fa-image"></i
                                    ></span>
                                </span>
                                <span class="level-item" v-if="item.audio">
                                    <span class="icon is-small"
                                        ><i class="fas fa-lg fa-volume-up"></i
                                    ></span>
                                </span>
                                <span class="level-item" v-if="item.video">
                                    <span class="icon is-small"
                                        ><i class="fab fa-lg fa-youtube"></i
                                    ></span>
                                </span>
                                <span class="level-item" v-if="item.url">
                                    <span class="icon is-small"
                                        ><i class="fas fa-lg fa-link"></i
                                    ></span>
                                </span>
                                <span class="level-item" v-if="item.tags">
                                    <span class="icon is-small"
                                        ><i class="fas fa-lg fa-tag"></i
                                    ></span>
                                </span>
                                <span
                                    class="level-item"
                                    v-if="item.files && item.files.length"
                                >
                                    <span class="icon is-small"
                                        ><i class="fas fa-lg fa-file"></i
                                    ></span>
                                </span>
                                <span class="level-item" v-if="item.embed">
                                    <span class="icon is-small"
                                        ><i class="fas fa-lg fa-code"></i
                                    ></span>
                                </span>
                            </div>
                        </nav>
                    </div>
                    <div class="media-right"></div>
                </article>
                <div class="lb-separator" />
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'underscore';
export default {
    components: {},
    props: {
        items: { type: Array, default: [] },
    },
    data() {
        return {
            slideUp: false,
            slideDown: true,
        };
    },
    filters: {
        strippedContent: function (string) {
            const div = document.createElement('div');
            div.innerHTML = string;
            const text = div.textContent || div.innerText || '';
            return text;
        },
    },
    computed: {},
    watch: {},
    mounted() {},
    methods: {
        centerMap(item) {
            this.$emit('centerMap', item);
            // console.log(this.$refs);
        },
        getObjectTypeIcon(object) {
            // console.log(object.type);
            if (object.type == 'zone') {
                return 'mdi mdi-24px mdi-vector-polygon';
            } else if (object.type == 'question') {
                return 'mdi mdi-24px mdi-map-marker-question-outline';
            } else {
                return 'mdi mdi-24px mdi-map-marker-outline';
            }
        },
    },
};
</script>

<style scoped>
.is-clipped {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
}
.object-element:hover {
    cursor: pointer;
    background-color: #f2f2f2;
}
</style>
